export default "__VITE_ASSET__BorwRlL9__"